import { useEffect } from 'react';

import { useConfig } from '@kega/sps-core';

import useTagManager from '../../hooks/useTagManager';

const TagManager = () => {
    const config = useConfig();

    const { initGTM } = useTagManager();

    const { tagmanagerkey } = config.get('google');

    useEffect(() => {
        
        if (tagmanagerkey) {
            initGTM({
                id: tagmanagerkey,
            });
        }
        
    }, []);

    return null;
}

export default TagManager;